import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-large);
  width: 100%;
  padding-block-end: var(--spacing-base);
  border-bottom: 6px solid var(--brand-500);

  & p {
    font-size: var(--font-size-text-sm);
    font-weight: var(--font-weight-semibold);
  }

  @media (width >= 48rem) {
    margin-block-end: var(--spacing-large);
    padding-block-end: var(--spacing-large);

    & p {
      font-size: var(--font-size-text-md);
    }
  }
`;
